import {LinkButton} from '@primer/react'
import {CommentIcon} from '@primer/octicons-react'
import type {IssueCommentInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@github-ui/react-router'
import {routeToIssueComment, useCurrentPathParams} from '../../../overview/data/use-comments-routing'

export function IssueCommentAction({info}: {info: IssueCommentInfo}) {
  const pathParams = useCurrentPathParams()
  const commentId = info.commentId

  if (!commentId) {
    return null
  }
  return (
    <LinkButton
      as={Link}
      to={routeToIssueComment(pathParams, commentId.toString())}
      size="small"
      variant="invisible"
      aria-label="View issue comment"
      icon={CommentIcon}
      className="flex-items-center"
    />
  )
}
